module.exports = __webpack_public_path__ + "img/D04444_AF2F2F_8B2424_9B2C2C-256px.50e8b5c4.png";